import React, { useState, useEffect } from "react";

const CryptoCoins = () => {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    const fetchCoins = async () => {
      try {
        const response = await fetch(
          "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd"
        );
        const data = await response.json();
        setCoins(data);
      } catch (error) {
        console.error("Error fetching coins:", error);
      }
    };

    fetchCoins();
  }, []);

  const formatPrice = (price) => {
    return `$${price.toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
  };

  return (
    <div className="crypto-container">
      <h2>Crypto Prices</h2>
      <table>
        <thead>
          <tr>
            <th>Coin</th>
            <th>Price (USD)</th>
            <th>24h Change (%)</th>
          </tr>
        </thead>
        <tbody>
          {coins.map((coin) => (
            <tr key={coin.id}>
              <td>
                <img
                  src={coin.image}
                  alt={coin.name}
                  style={{ width: 20, marginRight: 10 }}
                />
                {coin.name}
              </td>
              <td>{formatPrice(coin.current_price)}</td>
              <td
                style={{
                  color: coin.price_change_percentage_24h > 0 ? "green" : "red",
                }}
              >
                {coin.price_change_percentage_24h.toFixed(2)}%
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CryptoCoins;
